export default __webpack_public_path__ + "static/1279-aa173957fc1cc42463d07abac198c015.gif";